import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationRange } from '@kp/notifications/models/notification-info.model';

@Component({
  selector: 'kp-action-reminder-time-selector',
  templateUrl: './action-reminder-time-selector.component.html',
  styleUrls: ['./action-reminder-time-selector.component.scss'],
})
export class ActionReminderTimeSelectorComponent {
  @Input() time: string;
  @Output() timeEventEmitter = new EventEmitter<string>();

  modalOpened = false;
  notificationRange = NotificationRange;

  saveClicked(time: string) {
    this.time = time;
    this.timeEventEmitter.emit(time);
  }
}
